import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { track } from '@musinsa/packages-event-snowplow';
import type { FC } from 'react';
import { paths29CM, pathsMusinsa, useNavigate, useUserInfo } from '../../../common';
import { SNOWPLOW_SCHEME } from '../../../snowplow';
import { CuratorShopIcon } from '../EarningsBoostIcons';
import { EarningsBoostItem } from './EarningsBoostItem';

const LINK_ID = 'manage_curation_shop';
const LINK_TITLE = '큐레이션 샵 관리하기';
const LINK_TEXT = '소개하고 싶은 상품을 큐레이션해보세요';

export const LinkMusinsa: FC = () => {
  const { navigate } = useNavigate();
  const { data: userInfo } = useUserInfo();

  const handleClick = () => {
    if (!userInfo) return;

    amplitudeSendEvent({
      action_name: 'click',
      button_name: 'curating_try',
      component_name: 'button',
      event_name: 'click_button',
      from: getScreenName(),
      name: 'shop',
      section_name: 'mypage_dashboard',
    });
    pushDataLayer('click_button', {
      brand_id: GTM_NOTSET_STRING,
      button_id: 'curating_try',
      button_name: 'shop',
      index: GTM_NOTSET_STRING,
      section_index: '4',
      section_name: 'mypage_dashboard',
    });

    navigate(pathsMusinsa.myShop({ snsTitle: userInfo.snsTitle ?? '', query: { direct: true } }));
  };

  return (
    <EarningsBoostItem
      icon={<CuratorShopIcon />}
      title={LINK_TITLE}
      text={LINK_TEXT}
      onClick={handleClick}
    />
  );
};

export const Link29cm: FC = () => {
  const { navigate } = useNavigate();
  const handleClick = () => {
    track({
      schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
      data: {
        page_name: 'curator_mypage',
        section_name: 'IncreaseMyRevenue',
        section_title: '나의 수익 올리기',
        position: 4,
        button_id: LINK_ID,
        button_name: LINK_TITLE,
      },
    });

    navigate(paths29CM.myShop({ snsTitle: '' }));
  };
  return (
    <EarningsBoostItem
      icon={<CuratorShopIcon />}
      title={LINK_TITLE}
      text={LINK_TEXT}
      onClick={handleClick}
    />
  );
};

export const ManageCurationShopLink = {
  LinkMusinsa,
  Link29cm,
};
